import { render, staticRenderFns } from "./AcupunctureBody.vue?vue&type=template&id=4ca24fcb&"
import script from "./AcupunctureBody.vue?vue&type=script&lang=js&"
export * from "./AcupunctureBody.vue?vue&type=script&lang=js&"
import style0 from "./AcupunctureBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports